import L from "leaflet";

const grabHandleSize = 16;

// This mimics the custom handler icon used in ResizeAndTranslateTool
export const circleGrabHandleIcon = L.divIcon({
  className: "circle-arrow-handler-marker",
  iconSize: [grabHandleSize, grabHandleSize],
  html: `
    <div style="
      width:${grabHandleSize}px;
      height:${grabHandleSize}px;
      border-radius:50%;
      background:#fff;
      border:2px solid #3388ff;
      opacity:1;
      box-sizing:border-box;
      box-shadow:0 0 0 2px #3388ff33;
    "/>
  `,
});

export const squareGrabHandleIcon = L.divIcon({
  className: "square-arrow-handler-marker",
  iconSize: [grabHandleSize, grabHandleSize],
  html: `
    <div style="
      width:${grabHandleSize}px;
      height:${grabHandleSize}px;
      background:#fff;
      border:2px solid #3388ff;
      opacity:1;
      box-sizing:border-box;
      box-shadow:0 0 0 2px #3388ff33;
      cursor:move;
    "/>
  `,
});
